import { IconAi2Logo } from '@/components/icons/IconAi2Logo';
import { LoginButton } from '@/components/user/LoginButton';

import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

type ErrorPageProps = {
  error: string;
  errorDescription: string;
};

export const ErrorPage = ({ error, errorDescription }: ErrorPageProps) => {
  return (
    <ErrorPageContainer>
      <WrapperBox>
        <Box sx={{ mb: '9px' }}>
          <LogoContainer>
            <IconAi2Logo />
          </LogoContainer>
        </Box>
        <ErrorTitle variant="h1">{error}</ErrorTitle>
        <Typography variant="body2" sx={{ mb: '24px' }} component={'div'}>
          {errorDescription}
          <LoginButton displayIconOnly={false} />
        </Typography>
      </WrapperBox>
    </ErrorPageContainer>
  );
};

const WrapperBox = styled(Box)`
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 80%;
  width: 40%;
  margin: 0px auto;
`;

const ErrorTitle = styled(Typography)`
  &.MuiTypography-root {
    color: #ffffff;
  }
`;

const LogoContainer = styled('span')`
  display: inline-block;

  svg {
    width: 80%;
    height: auto;

    @media (min-width: 600px) {
      width: 100%;
    }
  }
`;

const ErrorPageContainer = styled('div')`
  background-color: #032629; // TODO: replace once varnish updates dark-blue-100 in theme
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  & > * {
    flex: 1 1 auto;
  }
`;
